import { API_URL } from '../../constants';
import Button, { ButtonStyle } from '../Button/Button';
import styles from './Product.module.scss';
import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import useDownloadFile from '../../hooks/useDownloadFile';
import IconButton from '../Button/IconButton';

const DownloadPDFButton = ({
    slug,
    filename,
    extraClasses,
    onlyIcon = false,
    disabled = false,
}) => {
    const { t } = useTranslation();
    const { downloadFile, isLoading } = useDownloadFile(
        API_URL,
        'product/pdf/:id',
        'application/pdf',
        true
    );
    const isButtonDisabled = isLoading || disabled;
    const handleDownload = async (e) => {
        e.stopPropagation();
        await downloadFile(slug, filename);
    };

    return onlyIcon ? (
        <IconButton
            onClick={isButtonDisabled ? undefined : handleDownload}
            icon={isLoading ? 'pulse-rings' : 'downloads'}
            tooltip={t('products.downloadAsPDF')}
            disabled={isButtonDisabled}
        />
    ) : (
        <Button
            text={isLoading ? t('products.pdfBeingGenerated') : t('products.downloadAsPDF')}
            style={ButtonStyle.PRIMARY}
            icon={isLoading ? 'pulse-rings' : 'downloads'}
            onClick={handleDownload}
            disabled={isButtonDisabled}
            extraClasses={classNames(styles.ProductDownloadPdfButton, extraClasses)}
        />
    );
};

DownloadPDFButton.propTypes = {
    slug: PropTypes.string.isRequired,
    filename: PropTypes.string.isRequired,
    onlyIcon: PropTypes.bool,
    extraClasses: PropTypes.string,
    disabled: PropTypes.bool,
};

export default DownloadPDFButton;
